<template>
  <div class="c-history p-1">
    <div class="c-history-nav">
      {{ i18n('history') }}
    </div>
    <app-timeline>
      <!-- 12 INVOICES HAVE BEEN PAID -->
      <app-timeline-item
        v-for="(item, i) in formatData"
        :key="i"
        :variant="item.variant"
      >
        <div class="d-flex flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <span>
            <h5
              style="white-space:nowrap;"
              class="mg-0"
            >
              {{ item.field }}
            </h5>
            <span style="white-space:nowrap;">
              {{ item.oldDataName ? item.oldDataName : item.oldData }}
            </span>
            <feather-icon
              icon="ArrowRightIcon"
              size="20"
            />
            <span
              class="text-warning"
              style="white-space:nowrap;"
            >
              {{ item.newDataName ? item.newDataName : item.newData }}
            </span>
          </span>
          <small class="text-muted">{{ item.createTime }}</small>
        </div>
        <p>{{ item.createStaff.realName }}</p>
      </app-timeline-item>
    </app-timeline>
  </div>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  BImg, BAvatar, BMedia, BButton, BCollapse, VBToggle, BListGroup, BListGroupItem, BAvatarGroup, BBadge, VBTooltip, Ripple,

} from 'bootstrap-vue'

export default {
  name: 'CHistory',
  components: {
    AppTimeline,
    AppTimelineItem,
    // BImg,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      variantDict: {
        1: 'primary',
        2: 'success',
        3: 'danger',
      },
    }
  },
  computed: {
    formatData() {
      const array = this.data
      const res = []
      array.forEach(item => {
        const param = item
        param.variant = this.variantDict[item.status]
        res.push(param)
      });
      return res.reverse()
    },
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.history.${param}`)
    },
  },
}

</script>

<style lang='scss' scoped>
.c-history{
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  &-nav{
    font-size: 18px;
    font-weight: 400;
    color: #5E5873;
    padding: 0.5rem 0;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.c-history{
  .app-timeline{
    height: calc(100% - 50px);
    padding-left: 10px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
